import m from "../../es2015/lang/pt_PT";
window.am4lang_pt_PT = m;


//////////////////
// WEBPACK FOOTER
// ./lang/pt_PT.js
// module id = null
// module chunks = 